import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterArticle_template} from "./filterArticle_template";

declare var ko: any;

export class pollsList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected dateFilter: filterDate_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected articleFilter: filterArticle_template;

    protected getTemplateHtml(): string {

        return `
            
            <div class="sub-header w-justify">
                <div class="w-left">
                    ` + this.dateFilter.getHtmlBuild() + `
                    <div style="margin-left: 1rem">
                    ` + this.articleFilter.getHtmlBuild() + `
                    </div>
                </div>
            </div>

                <div class="list-header w-justify" >
    
                    <div class="w-left" data-bind="if: isAddButtonShown">
                        <button data-bind="click: onClickAddPoll" class="btn secondary icon i-add" type="button">Create Poll</button>
                    </div>
    
                    <div class="w-center">
                         ` + this.filter.getHtmlBuild() + `
                    </div>
    
                    <div class="w-right">
                        ` + this.pagination.getHtmlBuild() + `
                    </div>
                </div>
            
            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Date Created</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateClosed') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Close Date</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: polls">
                        <tr class="cursor">
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: id"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: name"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: dateCreated"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: dateClosed"></span></a></td>
                        </tr>
                    </tbody>
                </table>
            </div>   
            
            `;
    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller)

        this.dateFilter = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.getTemplateViewModel().startDate(null);
        this.dateFilter.getTemplateViewModel().endDate(null);
        this.dateFilter.toggleClearButton(true);

        this.articleFilter = new filterArticle_template('articleFilter', this.getTemplateViewModel(), this.caller)
    }

    protected getTemplateName(): string {
        return "pollsList-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            orderBy: ko.observable("dateCreated")
            , orderByDirection: ko.observable("DESC")
            , polls: ko.observableArray([])
            , orderByAndDirection: ko.observable("dateCreated_DESC")
            , isAddButtonShown: ko.observable(true)
            , name : ko.observable()
            , onClickReorder: function (value, data, event) {
                huit_neuf_this.onClickReorder(value, data, event);
            }
            , onClickAddPoll: function () {
                huit_neuf_this.onClickAddPoll();
            }
            , onClickEdit: function (data) {
                huit_neuf_this.onClickEdit(data);
            }
        };
    }

    public buildDatePickerCalendar(){

        this.dateFilter.buildCalendar();
    }

    // poll save model
    public buildPollViewModel(){

        return {

            name: this.getTemplateViewModel().name
        }

    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy
            , orderByDirection: this.getTemplateViewModel().orderByDirection
            , orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            , pagination: this.getTemplateViewModel().pagination
            ,filters      : {
                keywords : this.getTemplateViewModel().filter.filterKeyword
                ,startDate: this.getTemplateViewModel().dateFilter.startDate
                ,endDate: this.getTemplateViewModel().dateFilter.endDate
                ,idArticle: this.getTemplateViewModel().articleFilter.idArticle
            },
        }
    }


    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.pollsListReorder();
    }

    public onClickAddPoll() {

        this.caller.addPoll();
    }

    public setPolls(polls) {

        this.getTemplateViewModel().polls(polls);
    }

    public onClickEdit(data){
        this.caller.viewPoll(data.id);
    }

    public setAddButtonShown(isAddButtonShown: boolean) {

        this.getTemplateViewModel().isAddButtonShown(isAddButtonShown);
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setArticlesFilter(articles) {

        this.getTemplateViewModel().articleFilter.articles(articles);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/pollsList_template.ts